<template>
  <div :class="classname">
    <div class="form_title" :style="'min-height:' + left_height + 'px'">
      {{ title }}
    </div>
    <!-- 小型组件 -->
    <template v-if="small">
      <div class="form_content">
        <div class="radio" v-if="radio">
          <el-select
            v-model="enterprise_nature"
            placeholder="请选择企业性质"
            class="inpyabeb"
            size="small"
          >
            <el-option label="事业单位" value="shiye"></el-option>
            <el-option label="国有企业" value="guoyou"></el-option>
            <el-option label="私营企业" value="siying"></el-option>
            <el-option label="外商独资企业" value="waishang"></el-option>
            <el-option label="中外合资企业" value="zhongwai"></el-option>
            <el-option
              label="境外非政府组织的境内代表机构"
              value="beijing"
            ></el-option>
            <el-option label="个体工商户" value="geti"></el-option>
            <el-option label="其他" value="qita"></el-option>
          </el-select>
        </div>
        <el-radio-group
          v-model="is_list2"
          size="small"
          class="inpyabeb"
          v-if="sex"
        >
          <el-radio
            :label="index"
            v-for="(item, index) in choice_list"
            :key="index"
            >{{ item }}</el-radio
          >
        </el-radio-group>
        <el-date-picker
          popper-class="popper"
          type="date"
          placeholder="选择日期"
          v-if="calendar"
          @change="change1"
        ></el-date-picker>
        <div class="input" v-if="text">
          <input type="text" :placeholder="placeholder" @input="Multiple1" />
          <span v-if="unit != ''">{{ unit }}</span>
        </div>
      </div>
      <div class="form_title" v-if="title2">{{ title2 }}</div>
      <div class="form_content" v-if="title2">
        <el-radio-group
          v-model="is_list"
          size="small"
          class="inpyabeb"
          v-if="sex"
        >
          <el-radio
            :label="index"
            v-for="(item, index) in choice_list"
            :key="index"
            >{{ item }}</el-radio
          >
        </el-radio-group>
        <div class="input" v-if="!sex2 && !calendar2">
          <input type="text" :placeholder="placeholder" @input="Multiple2" />
          <span v-if="unit2 != ''">{{ unit2 }}</span>
        </div>
        <el-date-picker
          v-model="date2"
          type="date"
          placeholder="选择日期"
          v-if="calendar2"
          @change="change2"
        ></el-date-picker>
      </div>
    </template>
    <!-- 长的输入框 -->
    <div class="form_long" v-if="long">
      <input :placeholder="placeholder" type="text" @input="Multiple1" />
    </div>
    <!-- 选择器 -->
    <div class="form_choice_long" v-if="choice">
      <el-radio-group @change="changeTheme" size="small" class="inpyabeb">
        <el-radio
          :label="index"
          v-for="(item, index) in choice_list"
          :key="index"
          >{{ item }}</el-radio
        >
      </el-radio-group>
    </div>
    <!-- 输入框和上传文件 -->
    <div class="Downinpustyle" v-if="isDowninpu">
      <div class="downineur" v-for="(item, index) in downlist" :key="index">
        <el-input
          :readonly="true"
          style="width: 100%; color: #0c0d0f"
          placeholder="请输入内容"
          size="small"
          v-model="item.name"
          prefix-icon="el-icon-paperclip"
        >
          <el-button
            slot="append"
            icon="el-icon-download"
            class="nejje"
            @click="down(item)"
            >下载</el-button
          >
        </el-input>
      </div>
      <el-upload
        class="upload-demo"
        style="height: 40px"
        accept=".doc, .docx, .pdf, .png, .jpg"
        :action="$baseURL+'/api/home/upload/file/user'"
        :on-change="onChange2"
        :on-remove="onremove2"
        :file-list="wordfile2"
        :before-upload = "beforeAvatarUpload"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip" v-if="wordfile2.length<1">
          只能上传doc、jpg、png、pdf文件，且不超过100MB
        </div>
      </el-upload>
    </div>
    <div class="input" v-if="choicetext">
      <input type="text" :placeholder="placeholder" @input="Multiple1" />
    </div>
    <!-- 输入文本框和日期选择器 -->
    <div class="form_textarea" v-if="textarea">
      <textarea
        name
        id
        cols="30"
        rows="10"
        :placeholder="placeholder"
        @input="updateVal"
      ></textarea>
      <el-date-picker
        v-if="calendar"
        @change="calendarchange"
        type="date"
        placeholder="选择日期"
      ></el-date-picker>
    </div>
    <!-- 上传图片 -->
    <div class="uploadimg" v-if="uploadimg">
      <el-upload
        class="upload-demo"
        :action="$baseURL+'/api/home/upload/file/user'"
        accept=".jpg, .png"
        :data="{ token: token }"
        :file-list="fileList"
        :limit="limit"
        list-type="picture-card"
        :on-exceed="handleExceed"
        :on-success="handleAdd"
        :before-upload = "beforeAvatarUpload"
      >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{ file }">
          <img class="el-upload-list__item-thumbnail" alt />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
								<i class="el-icon-download"></i>
            </span>-->
            <span
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" alt />
      </el-dialog>
    </div>
    <!-- 上传文件 -->
    <div class="uploadcertificate" v-if="certificate">
      <el-radio-group @change="changeTheme" v-model="isuploadisshow" size="small" class="inpyabeb">
        <el-radio label="1">有</el-radio>
        <el-radio label="0">无</el-radio>
      </el-radio-group>
      <el-upload
      v-if="isuploadisshow=='1'"
        class="upload-demo"
        :action="$baseURL+'/api/home/upload/file/user'"
        :on-change="handleChange"
        :on-remove="remove"
        :file-list="filechangeobj"
        :before-upload = "beforeAvatarUpload"
        accept=".jpg, .png, .pdf, .doc, .docx"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip" >
          {{filechangeobj.length==0?'只能上传doc、jpg、png、pdf文件，且不超过100MB':''}}
        </div>
      </el-upload>
    </div>
      <div class="uploadcertificate" v-if="certificatePdf">
          <el-radio-group @change="changeTheme" v-model="isuploadisshow" size="small" class="inpyabeb">
              <el-radio label="1">有</el-radio>
              <el-radio label="0">无</el-radio>
          </el-radio-group>
          <el-upload
              v-if="isuploadisshow=='1'"
              class="upload-demo"
              :action="$baseURL+'/api/home/upload/file/userPdf'"
              :on-change="handleChange"
              :on-remove="remove"
              :file-list="filechangeobj"
              :before-upload = "beforeAvatarUpload"
              accept=".pdf"
          >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" >
                  {{filechangeobj.length==0?'只能上传pdf文件，且不超过100MB':''}}
              </div>
          </el-upload>
      </div>
    <div class="uploadcertificate" v-if="certificatetwo">
      <el-radio-group @change="changeTheme2" v-model="isuploadisshow2" size="small" class="inpyabeb w160">
        <el-radio label="1">已备案</el-radio>
        <el-radio label="0">未备案</el-radio>
      </el-radio-group>
      <el-upload
      v-if="isuploadisshow2==1"
        class="upload-demo"
        :action="$baseURL+'/api/home/upload/file/user'"
        :on-change="handleChange2"
        :file-list="filechangeobj2"
        :before-upload = "beforeAvatarUpload"
        accept=".jpg, .png, .pdf, .doc, .docx"
      >
        <el-button size="small" type="primary">上传备案表</el-button>
        <div slot="tip" class="el-upload__tip">
          {{ filechangeobj2?'':'只能上传doc、jpg、png、pdf文件，且不超过100MB' }}
        </div>
      </el-upload>
    </div>
      <div class="uploadcertificate" v-if="certificatethree">
          <el-radio-group @change="changeTheme" v-model="isuploadisshow" size="small" class="inpyabeb">
              <el-radio label="1">有</el-radio>
              <el-radio label="0">无</el-radio>
          </el-radio-group>
          <el-upload
              v-if="isuploadisshow=='1'"
              class="upload-demo"
              :action="$baseURL+'/api/home/upload/file/uservideo'"
              :on-change="handleChange"
              :on-remove="remove"
              :file-list="filechangeobj"
              :before-upload = "beforeAvatarUpload"
              accept=".mp4,.avi"
          >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" >
                  {{filechangeobj.length==0?'只能上传mp4,avi文件，且不超过100MB':''}}
              </div>
          </el-upload>
      </div>
      <div class="uploadcertificate" v-if="certificatefour" style="display: block">
          <div style="display: flex">
              <el-radio-group @change="changeTheme" v-model="isuploadisshow" size="small" class="inpyabeb">
                  <el-radio label="1">有</el-radio>
                  <el-radio label="0">无</el-radio>
              </el-radio-group>
              <el-upload v-if="isuploadisshow=='1'"
                  class="upload-demo" :show-file-list="false"
                         :action="$baseURL + '/api/home/upload/file/userimg'"
                  :on-remove="remove" :on-change="handleChange3"
                  :file-list="filechangeobj"
                  :before-upload = "beforeAvatarUpload2"
                  accept=".jpg, .png">
                  <el-button size="small" class="el-icon-upload el-icon--left action_upload">  选择图片</el-button>
                  <div slot="tip" class="el-upload__tip">
                      仅支持jpg,png格式，大小不超过20mb
                  </div>
              </el-upload>
          </div>
          <div>
              <div v-for="(item,index) in filechangeobj" :key="item.id" class="el-upload-list__item-thumbnail">
                  <img v-if="item.response&&item.response.data&&item.response.data.url" class="img" :src="item.response.data.host+item.response.data.url" :alt="item.name"/>
                  <img v-if="item.response&&item.response.data&&item.response.data.url" @click="closeImg(index)" class="el-icon-close" src="@/assets/close.png"/>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    filechangelist: {
      type: Array,
      default(){
        return []
      }
    },
    filechangelist2: {
      type: Array,
      default(){
        return []
      }
    },
    wordfile:{
      type: Array,
      default(){
        return []
      }
    },
    isuploadisshow2:{
      type:String,
      default:'0'
    },
    isuploadisshow:{
      type:String,
      default:'0'
    },
    radio: {
      type: Boolean,
      default: false,
    },
    certificatetwo:{
       type: Boolean,
        default: false,
    },
      certificatethree:{
          type: Boolean,
          default: false,
      },
      certificatefour:{
          type: Boolean,
          default: false,
      },
    certificate: {
      type: Boolean,
      default: false,
    },
      certificatePdf:{
          type: Boolean,
          default: false,
      },
    placeholder: {
      type: String,
      default: "点击输入",
    },
    uploadinput: {
      type: Boolean,
      default: false,
    },
    isDowninpu: {
      type: Boolean,
      default: false,
    },
    choicetext: {
      type: Boolean,
      default: false,
    },
    sex: {
      type: Boolean,
      default: false,
    },
    sex2: {
      type: Boolean,
      default: false,
    },
    classname: {
      type: String,
      default: "my_form",
    },
    text: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: "",
    },
    unit2: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "xxx",
    },
    title2: {},
    small: {
      type: Boolean,
      default: false,
    },
    long: {
      type: Boolean,
      default: false,
    },
    uploadimg: {
      type: Boolean,
      default: false,
    },
    left_height: {
      type: Number,
      default: 62,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    calendar: {
      type: Boolean,
      default: false,
    },
    calendar2: {
      type: Boolean,
      default: false,
    },
    choice: {
      type: Boolean,
      default: false,
    },
    choice_list: {
      type: Array,
    },
    choice_list2: {
      type: Array,
    },
  },
  model: {
    prop: "",
    event: "input",
  },
  watch:{
    isuploadshow:function() {
      if (this.isuploadshow==0) {
        this.filechangeobj = []
        this.$emit("filechange", [{title:this.title}]);
      }
    }
  },
  computed: {
      normalizedSize: function () {
        return this.filechangelist.trim().toLowerCase()
      },
      normalizedSize2: function () {
        return this.filechangelist2.trim().toLowerCase()
      },
      normalizedSize3: function () {
        return this.wordfile.trim().toLowerCase()
      },
    },
  data() {
    return {
      filechangeobj:this.filechangelist,
      filechangeobj2:this.filechangelist2,
      wordfile2: this.wordfile,
      isuploadshow:'1',
      isuploadshow2:'1',
      enterprise_nature: "",
      downlist: [
        {
          name: "房屋建筑、市政园林工程用表",
          url: "/user/房屋建筑、市政园林工程用表.doc",
        },
        {
          name: "工业交通水利工程用表",
          url: "/user/工业交通水利工程用表.doc",
        },
        // {
        //   name:"贵州省黄果树杯优质工程申报单位承诺书",
        //   url:"/user/贵州省黄果树杯优质工程申报单位承诺书.doc"
        // }
      ],
      datalist: [],
      updateValclea: {},
      fileList: [
        {
          name: "upload",
          url: "",
        },
      ],
      limit: 1,
      token: "",
      is_list: 0,
      is_list2: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      business_license: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      yearmonthday: [],
      date1: "",
      date2: "",
      Multipletext: [],
    };
  },
  mounted() {
    this.token = "Bearer " + localStorage.getItem("TOKEN");
  },
  methods: {
    //限制文件上传大小
    beforeAvatarUpload(file){
      let filesize = (Math.ceil(file.size / 1024)/1024).toFixed(2)
      if (filesize>100) {
        this.$message.error('上传文件不能大于100MB')
        return false
      }
    },
      beforeAvatarUpload2(file){
          let filesize = (Math.ceil(file.size / 1024)/1024).toFixed(2)
          if (filesize>20) {
              this.$message.error('上传文件不能大于20MB')
              return false
          }
      },
    down(item) {
      window.open(item.url);
    },
    remove(){
      this.$emit("filechange", [{title:this.title}]);
    },
    handleChange(file, fileList) {
      this.datalist = fileList.slice(fileList.length - 1);
      this.datalist[0].title = this.title;
      if (this.datalist[0].response!=undefined) {
        this.filechangeobj = [{
          name:this.datalist[0].response.data.originalName,
          url:this.datalist[0].response.data.host+this.datalist[0].response.data.url
        }]
      }
      this.$emit("filechange", this.datalist);
    },
      handleChange3(file, fileList){
        console.log(fileList,'fileList_myform');
          this.datalist = fileList.slice(fileList.length - 1);
          this.datalist[0].title = this.title;
          if (this.datalist[0].response!=undefined) {
              if(!this.filechangeobj){
                  this.filechangeobj = [];
              }
              this.filechangeobj.push(this.datalist[0]);
              // this.filechangeobj.push({
              //     name:this.datalist[0].response.data.originalName,
              //     url:this.datalist[0].response.data.host+this.datalist[0].response.data.url,
              //     uid:this.datalist[0].uid
              // });
          }
          this.$emit("filechange", this.datalist);
      },
      closeImg(index){
          this.filechangeobj.splice(index,1);
          this.$emit("fileSplice", index);
      },
    changeTheme(e){
      this.$emit('isuploadshow',e.toString())
      this.filechangeobj = []
    },
    handleChange2(file, fileList) {
      this.datalist = fileList.slice(fileList.length - 1);
      this.datalist[0].title = this.title;
      this.filechangeobj2 = this.datalist
      this.$emit("filechange2", this.datalist);
    },
    changeTheme2(e){
      this.filechangeobj2 = []
      this.$emit('isuploadshow2',e.toString())
    },
    onChange2(file, fileList){
      this.wordfile2 = [fileList[fileList.length-1]]
      this.$emit('onChange2', this.wordfile2)
    },
    onremove2(){
      this.wordfile2 = []
      this.$emit('onChange2', this.wordfile2)
    }
  },
};
</script>

<style lang="less" scoped>
.el-upload-list__item-thumbnail{
    border:1px solid #ebe7e7;
    margin-left:20px;
    margin-bottom: 20px;
    width: 70px;
    height: 70px;
    float: left;
}
.el-upload-list__item-thumbnail .img{
    width:70px;
    height: 70px;
}
.el-icon-close{
    position: absolute;
    margin-top:-12px;
    margin-left: -12px;
}
.inpyabeb {
  width: 100px;
  display: flex;
  align-items: center;
  height: 100px;
  padding-left: 20px;
  background: #f5f8fb;
}
.w160{
  width: 160px;
}
.downineur{
  margin: 0 10px;
}
.uploadcertificate{
  width: 729px;
  display: flex;
  align-items: center;
   background: #f5f8fb;
}
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 609px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form {
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .inpyabeb,
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle,
  .uploadcertificate {
    background: #fbfdff;
  }
}
</style>
